import React from 'react';
import { Dialog } from 'primereact/dialog';
import { FormCurveTime } from './FormCurveTime';
import { DeleteCurveTime } from './DeleteCurveTime';

export const DialogCurveTime = (props) => {
    const {
      modal, toggle, modalTitle, method, loading, handleInputChange, saveCreate, saveUpdate, saveDelete, validations, time_in_minutes, label, time_valid, label_valid, closeModalCurves
    } = props;

    const dialogClassName =
            method === "delete"
                ? "medium-dialog delete-method"
                : "medium-dialog"; 
    return (
        <Dialog
            header={modalTitle}
            visible={modal}                     
            modal
            closable
            closeOnEscape={false}
            onHide={closeModalCurves}
            draggable={false}
            resizable={false}
            className={dialogClassName}
        >
            {method === "create" ? (
                <FormCurveTime
                    button="Crear"
                    {...{
                          modal, closeModalCurves, modalTitle, method, loading, handleInputChange, validations, time_in_minutes, label, time_valid, label_valid,

                        methodAction: saveCreate
                    }}
                />
            ) : method === "update" ? (
                <FormCurveTime
                    button="Actualizar Tiempo"
                    {...{
                          modal, closeModalCurves, modalTitle, method, loading, handleInputChange, validations, time_in_minutes, label, time_valid, label_valid,
                        methodAction: saveUpdate
                    }}
                />
            ) : (
                <DeleteCurveTime
                    {...{ closeModalCurves, loading, label, time_in_minutes, saveDelete }}
                />
            )}
        </Dialog>
    );
};
